<template>
  <BCard>
     <BRow> 
      <BCol cols="12">
        <h4 class="mb-2">{{$t('General data')}}</h4> 
      </BCol> 

      <!-- Datos de contacto: Left col -->
      <BCol cols="12" xl="6" >
        <table class="mt-2 mt-xl-0 w-100">
          <ViewData vsIcon="HomeIcon" vsLabel="Name" :vsValue="group.name" />
          <ViewData vsIcon="SmartphoneIcon" vsLabel="Phone" :vsValue="group.phone" />
          <ViewData vsIcon="PhoneIcon" vsLabel="Phone 2" :vsValue="group.phone2" />
          <ViewData vsIcon="CompassIcon" vsLabel="Address" :vsValue="group.address" />
          <ViewData vsIcon="CompassIcon" vsLabel="Postal code" :vsValue="group.postal_code" />
        </table>
      </BCol>

      <!-- Datos de contacto: Right col -->
      <BCol cols="12" xl="6" >
        <table class="mt-2 mt-xl-0 w-100">
          <ViewData vsIcon="HomeIcon" vsLabel="Business name" :vsValue="group.company_name" />
          <ViewData vsIcon="GlobeIcon" vsLabel="Town" :vsValue="group.city" />
          <ViewData vsIcon="GlobeIcon" vsLabel="Province" :vsValue="group.province.name" />
          <ViewData vsIcon="GlobeIcon" vsLabel="Country" :vsValue="group.country.name" />
          <ViewData vsIcon="MailIcon" vsLabel="Email" :vsValue="group.email" />
          <ViewData vsIcon="UserCheckIcon" vsLabel="Status" :vsValue="group.status" vsCheckbox />
        </table>
      </BCol>

    </BRow>
  </BCard>
</template>

<script>
import { BCard, BButton, BAvatar, BRow, BCol, BFormCheckbox } from 'bootstrap-vue'
import { inject } from '@vue/composition-api';
import ViewData from '@/components/ViewData.vue';

export default {
  components: { BCard, BButton, BRow, BCol, BAvatar, BFormCheckbox, ViewData },
  setup() {
    const group = inject('group')

    return {
      group
    }
  },
}
</script>

<style lang="scss">
@import 'src/assets/scss/variables/_variables.scss';
table tr th {
  color: $primary;
}

table tr th span {
  text-transform: uppercase;
}
</style>
